module.exports = __webpack_public_path__ + "img/live.4b0ff199.svg";